const helloAndGoodbye = {
  roleplayId: "nualang.hello-goodbye.0.0.1",
  roleplayName: "Olá e adeus",
  description: "Aprenda a dizer olá e adeus",
  difficulty: "ALL",
  learnLang: "portuguese",
  picture: "",
  actor1: {
    name: "Ines",
    voice: "Vitoria",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMi5wbmcifQ==",
  },
  actor2: {
    name: "Cristiano",
    voice: "Antonio",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwNi5wbmcifQ==",
  },
  script: [
    { text: "Olá. Como vai você?", actor: 1 },
    { text: "Eu estou bem. Obrigado por perguntar. Como você está?", actor: 2 },
    { text: "Não posso reclamar, a vida está me tratando bem.", actor: 1 },
    { text: "É bom ouvir isso.", actor: 2 },
    {
      text: "É bom vê-lo novamente, eu preciso ir à consulta do meu médico.",
      actor: 2,
    },
    { text: "Bom ver você.", actor: 1 },
    { text: "Até logo.", actor: 2 },
  ],
};

export default helloAndGoodbye;
